import { format, parseISO } from 'date-fns'
import { datetime } from '~/shared/config'
import { AsyncGridColumns } from '~/shared/ui/AsyncGrid'
import { ChipStatus } from '~/shared/ui/Chips'
import { Gallery } from '~/shared/ui/Gallery'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.inspection date',
    field: 'inspectionFinishedAt',
    flex: 1,
    sortable: false,
    renderCell: ({ value: inspectionFinishedAt }) =>
      inspectionFinishedAt &&
      format(parseISO(inspectionFinishedAt), datetime.uiDateFormat),
  },
  {
    headerName: 'column.car detail',
    field: 'carDetail',
    flex: 1,
    sortable: false,
  },
  {
    headerName: 'column.damage extent',
    field: 'carDamageExtend',
    flex: 1,
    sortable: false,
  },
  {
    headerName: 'column.damage cost',
    field: 'cost',
    flex: 1,
    sortable: false,
    renderCell: ({ value }) => value && value.toLocaleString(),
  },
  {
    headerName: 'column.photos',
    field: 'photos',
    flex: 1,
    sortable: false,
    renderCell: ({ value }) => (
      <Gallery
        buttonTitle='button.open'
        buttonProps={{
          variant: 'textBrand',
          size: 'sm',
        }}
        showList={false}
        images={value}
      />
    ),
  },
  {
    headerName: 'column.driver full name',
    field: 'driverFullName',
    flex: 1,
    sortable: false,
  },
  {
    headerName: 'column.repaired',
    field: 'isRepair',
    flex: 1,
    sortable: false,
    renderCell: ({ value }) => (
      <ChipStatus
        variant={value ? 'green' : 'red'}
        labelI18n={value ? 'column.yes' : 'column.no'}
      />
    ),
  },
]
